import { render, staticRenderFns } from "./NftScrollableTable.vue?vue&type=template&id=1bf6a701&scoped=true"
import script from "./NftScrollableTable.vue?vue&type=script&lang=ts"
export * from "./NftScrollableTable.vue?vue&type=script&lang=ts"
import style0 from "./NftScrollableTable.vue?vue&type=style&index=0&id=1bf6a701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6a701",
  null
  
)

export default component.exports